import type { ClipBoxMode, ClipBoxState } from '../atoms/viewer.atom';

export type SavedViewCamera = {
  position: [number, number, number];
  target: [number, number, number];
  azimuth: number;
  polar: number;
  distance: number;
  zoom: number;
  ortho: boolean;
  thirdPerson: boolean;
};

export type SavedViewClipBox = {
  enabled: boolean;
  center: [number, number, number] | null;
  halfSize: [number, number, number];
  rotation: [number, number, number, number];
  clipMode: ClipBoxMode;
};

type StoredCameraLike = {
  azimuth: number;
  polar: number;
  distance: number;
  zoom: number;
  position: [number, number, number];
  target: [number, number, number];
  ortho?: boolean;
  thirdPerson?: boolean;
};

export const normalizeCamera = (stored: StoredCameraLike): SavedViewCamera => ({
  position: stored.position,
  target: stored.target,
  azimuth: stored.azimuth,
  polar: stored.polar,
  distance: stored.distance,
  zoom: stored.zoom,
  ortho: stored.ortho ?? false,
  thirdPerson: stored.thirdPerson ?? false,
});

export const serializeClipBox = (state: ClipBoxState): SavedViewClipBox => ({
  enabled: state.enabled,
  center: state.center,
  halfSize: state.halfSize,
  rotation: state.rotation,
  clipMode: state.clipMode,
});

export const deserializeClipBox = (saved: SavedViewClipBox): ClipBoxState => ({
  enabled: saved.enabled,
  center: saved.center,
  halfSize: saved.halfSize,
  rotation: saved.rotation,
  clipMode: saved.clipMode,
  interactionMode: 'VIEW',
});

export const filterVisibleLayerIds = (savedIds: string[], existingIds: string[]): string[] => {
  const existing = new Set(existingIds);
  return savedIds.filter((id) => existing.has(id));
};
